module.exports = __webpack_public_path__ + "img/3.fcd40747.jpg";